import styled from "styled-components";

import { ButtonPrimaryLink, ButtonSecondaryLink } from "@components/Button";
import Layout from "@components/Layout";

import { Row } from "@styles/grid";

import ProductsTable from "./ProductsTable";
import { getAllProducts } from "@actions/products.action";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem auto 5.5rem;
  max-width: 125rem;
  width: 100%;
  padding: 0 2.5rem;
`;

const Products = () => {
  const { products } = useSelector(({ products }) => products);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      if (!products || !products.length) {
        await dispatch(getAllProducts("category,brand"));
      }
    })();
  }, [products]);

  return (
    <Layout pageTitle="Products">
      <Content>
        <Row justify="space-between" margin="2rem 0">
          <ButtonSecondaryLink outlined uppercase href="/">
            Back to Dashboard
          </ButtonSecondaryLink>
          <ButtonPrimaryLink uppercase href="/products/add">
            Add product
          </ButtonPrimaryLink>
        </Row>
        <ProductsTable />
      </Content>
    </Layout>
  );
};

export default Products;
